import React from 'react'
import blogimageone from '../../Assets/blogone.svg'
import blogimagetwo from '../../Assets/blogtwo.svg'
import blogimagethree from '../../Assets/blogthree.svg'
import AOS from "aos";
import { useEffect } from 'react';
import "aos/dist/aos.css";

const blogs = [
	{
		img: blogimageone,
		tag: 'Values & Culture',
		date: 'June 2025',
		title: 'Rooted in Values, Ready for Tomorrow: The Éloria Way',
		text: 'At Éloria, education is more than academics — it is a transformative journey that shapes the next generation with souls engraved in spiritual values and skills chiselled to meet the unseen future of science and technology.',
	},
	{
		img: blogimagetwo,
		tag: 'Curriculum',
		date: 'May 2025',
		title: "From Coding to Conscience: Éloria's Holistic Curriculum",
		text: 'At Éloria, we blend spiritual depth with modern skills — from coding and critical thinking to science and technology — ensuring every student finds her strength and achieves her highest potential.',
	},
	{
		img: blogimagethree,
		tag: 'Leadership',
		date: 'April 2025',
		title: "Building the Leaders of Tomorrow: Éloria's Commitment to National Growth",
		text: 'Éloria stands as the fulfilment of the dream of a skilled young generation who can contribute to national resources and boost moral development.',
	},
];

const Blog = () => {

	useEffect(() => {
		AOS.init({ disable: "phone", duration: 700 });
	}, []);

	return (
		<div className="blog-main-section">
			<div className="container-main">
				<div className="blog-header-row">
					<div>
						<span className="blog-label">Our Insights</span>
						<h1 className="blog-heading mb-0">Latest Blogs</h1>
					</div>
					<p className="blog-header-sub">Stay updated with the latest from Éloria — stories of growth, learning, and purpose.</p>
				</div>
				<div className="blog-cards-grid">
					{blogs.map((blog, i) => (
						<div className="blog-card" data-aos="fade-up" data-aos-delay={i * 100} key={i}>
							<div className="blog-card-img-wrap">
								<img src={blog.img} className="blog-card-img" alt={blog.title} />
								<span className="blog-card-tag">{blog.tag}</span>
							</div>
							<div className="blog-card-body">
								<div className="blog-card-meta">
									<i className="ri-calendar-line"></i> {blog.date}
								</div>
								<h4 className="blog-card-title">{blog.title}</h4>
								<p className="blog-card-text">{blog.text}</p>
								<button className="blog-read-more">
									Read More <i className="ri-arrow-right-line"></i>
								</button>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default Blog
